export default {
    layout: {
        default: ["1 2 3", "4 5 6", "7 8 9", "- 0 {bksp}", "{letter}  {enter}"],
        letter: [  "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "- Z X C V B N M {bksp}",
        "{default} {space} {enter}"]

      },
      display: {
        "{bksp}": "⌫",
        "{enter}": "Buscar ↵",
        "{shift}": "shift ⇧",
        "{letter}": "ABC",
        "{default}": "123",
      }
}